export const isBetPage = (isEditLineIncubator = false): boolean => {
    const {pathname} = window.location;

    return pathname.includes('/play/live') || pathname.includes('/play/express') ||
        pathname.includes('/play/bets') || pathname.includes('/play/results') || pathname.includes('/play/quick_bets') ||
        (isEditLineIncubator ? pathname.includes('/play/incubator/all') : pathname.includes('/play/incubator'));
};
